import { CommunityChannelApi } from '@ps/api/community-channel';
import { withClientAPI } from '@ps/functions/utils/api';

/**
 * Delete a community channel. Server cascades the membership and
 * messages, removes the channel doc, and our Firestore channel-list
 * subscription delivers the removal so the list updates without a
 * refetch.
 */
export async function deleteChannel({
  creatorId,
  channelId,
}: {
  creatorId: string;
  channelId: string;
}): Promise<void> {
  const api = withClientAPI(CommunityChannelApi);
  await api.communityChannelApiControllerDeleteCommunityChannel({
    sellerId: creatorId,
    channelId,
  });
}
